module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-5c56c5defadcd26953fff4032717f41d.webp";